import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterUser_template} from "./filterUser_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterSingleDate_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template';
import {imagePicker_template} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import {imagePicker_template_mockup} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template_mockup';

declare var ko: any;

export class articlesEdit_template extends vnTemplate{

    protected filterUser_author: filterUser_template;
    protected filterUser_SrEditor: filterUser_template;
    protected filterUser_JrEditor: filterUser_template;
    protected filterDisplay_author: filterUser_template;
    protected paymentCategoryFilter: filterDropdown_template;
    public datePicker: filterSingleDate_template;
    public imagePicker: imagePicker_template;
    public imagePickerM: imagePicker_template_mockup;

    protected getTemplateHtml(): string{

        return `
                <div class="w-form w-form-large">
                
                    <div class="form-header">
                        <h3 class="form-title icon i-edit">Article Edit</h3>
                        <button class="close-button icon i-close-2" data-bind="event: { click: onClickCancel }" type="button"></button>
                    </div>
                    
                    <div class="w-form-body">
                    
                        <div class="form-body">
                           <strong class="form-sub-title icon i-article">General Info</strong>
                            
                            
                            <div class="form-group">
                                <strong class="form-content-title"  data-bind="text: title"></strong>
                            </div>
                            
                            <div class="form-group row">
                                <span class="status-label">published on<span class="icon i-calendar-b" data-bind="text: datePublished"></span></span>
                                <select id="idPublishStatus" data-bind="options: publishStatuses, optionsText: 'name', value: idPublishStatus, optionsValue: 'id'"></select>
                            </div>

                            <div class="form-group">
                                <dl class="double-list">
                                                              
                                    <dt>
                                        <span>Emaki post ID</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: id"></span>
                                    </dd>   
                                    <dt>
                                        <span>WP post ID</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: reference"></span>
                                    </dd>
                                  
                                    <dt class="full-width">
                                        <span>Permalink</span>
                                    </dt>
                                    
                                    <dd class="full-width">
                                        <span style="text-transform: none" data-bind="text: permalink, visible: !allowEditPermalink()"></span>
                                        <input type="text" class="input-text" data-bind="visible: allowEditPermalink(), value: permalink"/>
                                    </dd>
                                                                                                                                                                     
                                </dl>
                            </div>
                                                        
                            <strong class="form-sub-title icon i-user">Users</strong>
                            <div class="form-group">
                                <dl class="double-list">                                                                      
                                    
                                    <dt>
                                        <span>Sr Editor</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: editor"></span>
                                    </dd>
                                    <dt>
                                        <span>Jr Editor</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: author"></span>
                                    </dd>
                                    <dt>
                                        <span >Author</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: author"></span>
                                    </dd>
                                    <!-- ko ifnot: isEditShown -->
                                     <dt>
                                        <span >Display Author</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: displayAuthor"></span>
                                        <button data-bind="event: { click: onClickEditDisplayAuthor }" class="btn no-bg icon i-edit" type="button"></button>
                                    </dd>
                                    <!-- /ko -->
                                                                
                                </dl>
                            </div>
                            
                            <!-- ko if: isEditShown -->
                            <div class="form-group">
                                <dt class="full-width">
                                    <span>Set Display Author</span>
                                </dt>
                                <dd class="full-width">
                                   ` + this.filterDisplay_author.getHtmlBuild() + `
                                </dd>
                            </div>
                            <!-- /ko -->
                            <strong class="form-sub-title icon i-payment">Payment</strong>
                            <div class="form-group">
                                <dl class="double-list">                                                                    
                                    <dt>
                                        <span>Payment Category</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: postPaymentCategory"></span>
                                    </dd>
                                </dl>
                            </div>
                            <strong class="form-sub-title icon i-settings">Settings</strong>
                            
                            <div class="form-group">
                                <dl class="double-list">
                                    
                                    <dt>
                                        <span>Target Audience</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: targetAudience"></span>
                                    </dd>
                                    <dt>
                                        <span>Intent</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: intent"></span>
                                    </dd>
                                    <dt>
                                        <span>Content Type</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: contentType"></span>
                                    </dd>
                                    <dt>
                                        <span>Network Category</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: networkCategory"></span>
                                    </dd>
                                </dl>
                            </div>
                            
                            <strong class="form-sub-title icon i-article">Amazon Onsite</strong>
                            <div class="form-group">
                                <dl class="double-list">
                                                      
                                    <dt class="full-width">
                                        <span>On site article title</span>
                                    </dt>
                                    
                                    <dd class="full-width">
                                        <input type="text" class="input-text" data-bind="value: amazonsiteArticleTitle"/>
                                    </dd>
                                    
                                     <dt class="full-width">
                                        <label for="singleDatePicker"><span>On site published date</span></label>
                                    </dt>    
                                    <dd class="full-width">
                                       ` + this.datePicker.getHtmlBuild() + `
                                    </dd>
                                                                                                                                                                     
                                </dl>
                            </div>    
                            
                                    
                        </div>
                                               
                        
                        <div class="form-body">
                            <strong class="form-sub-title icon i-redo">Republish History</strong>
                            
                         
                                
                            <div class="form-group">
                                <button class="btn full-width highlight icon i-redo" type="button" data-bind="event: { click: createNewRepublish }, visible: showNewRepublishButton">Create New Republish</button>
                                <button class="btn full-width dark icon i-x-before" type="button" data-bind="event: { click: cancelNewRepublish }, visible : showCancelRepublishButton ">Cancel New Republish</button>
                            </div>
                            
                            
                            <div class="w-form-group new-republish" data-bind="visible : showNewRepublish ">
                               
                                <div class="form-group w-form-sub-title">
                                    <strong class="form-sub-title">New Republish<span class="icon i-calendar-b" data-bind="text: newRepublishDate"></span>
                                        <button class="w-tooltips icon i-tooltips" type="button">
                                            <span class="tooltips bottom">Republish will be taken into consideration upon saving the article</span>
                                        </button>
                                    </strong>
                                </div>
                                
                                <div class="form-group">
                                    <label for="authorName" class="form-label">Author</label>
                                     ` + this.filterUser_author.getHtmlBuild() + `
                                </div>
                                
                                <div class="form-group">
                                    <label for="srEditorName" class="form-label">Sr Editor</label>
                                     ` + this.filterUser_SrEditor.getHtmlBuild() + `
                                </div>
                                
                                <div class="form-group">
                                    <label for="jrEditorName" class="form-label ">Jr Editor</label>
                                     ` + this.filterUser_JrEditor.getHtmlBuild() + `
                                </div>
                                
                                <div class="form-group">
                                    <strong class="form-sub-title">Payment</strong>
                                </div>
                                
                                <div class="form-group" style="display: flex;align-items: center">
                                    <label class="form-label form-label-box" style="margin-right: .5rem">Payment Category</label>
                                    ` + this.paymentCategoryFilter.getHtmlBuild() + `
                                </div>
                                
                                <div class="form-group">
                                    <hr>
                                </div>
                                
<!--                                <div class="form-group">-->
<!--                                    <label class="form-label">Author Payment</label>-->
<!--                                    <input id="amountAuthor" data-bind="value: amountAuthor" class="input-text amount" type="text">-->
<!--                                </div>-->

                            <!--Payment type dropdown-->
                            <div class="form-group-group select">
                                <div class="form-group"> 
                                    <label class="form-label form-label-box">Author Payment</label>
                                    <select
                                    data-bind="options: paymentTypeRepublish,
                                               optionsCaption: 'Choose a payment type',
                                               optionsValue: 'name', 
                                               optionsText: 'name' , 
                                               value: choosenPaymentTypeRepublish,
                                               event : {change : onChangepaymentTypeRepublish } "
                                               >
                                    </select>
                                </div>
                                 <!-- Show Input -->
                                <div class="form-group row" style="justify-content: flex-start" data-bind="visible: choosenPaymentTypeRepublish">
                                    <!-- ko if: choosenPaymentTypeRepublish() == 'Amount' -->
                                
                                    <input  id="amountAuthor" 
                                        style="text-transform: capitalize; width: 12rem;"
                                        data-bind=" value: amountAuthor,
                                                    attr: { 'placeholder':  choosenPaymentTypeRepublish().toLowerCase() }" 
                                        class="input-text" 
                                        type="number"
                                    >
                                    <span style="display: inline-block;margin-left: .5rem" class="form-indic">$</span>
                               
                                    <!-- /ko -->
                                    
                                    <!-- ko if: choosenPaymentTypeRepublish() == 'Percentage' -->
                                    
                                    <input  id="percentageAuthor" 
                                        style="text-transform: capitalize; width: 12rem;"
                                        data-bind="value: percentageAuthor,
                                                    attr: { 'placeholder':  choosenPaymentTypeRepublish().toLowerCase() }" 
                                        class="input-text" 
                                        type="number"
                                        min="1"
                                        max="999"
                                        step="any"
                                    >
                                    <span style="margin-left: .5rem;display: inline-block" class="form-indic">%</span>
                                    <!-- /ko -->
                                </div>                          
                            </div>
                            
                            <div class="form-group">
                                <hr>
                            </div>
                            
                             <!-- Edirepublish-newtor percentage (Always %) -->
                            <div class="form-group inside-label row start">
                                <label class="form-label">Editor Payment</label>
                                <input
                                    style="text-transform: capitalize; width: 12rem;"
                                    data-bind="value: percentageEditor,
                                                attr: { 'placeholder': 'Percentage' }" 
                                    class="input-text num" 
                                    type="number"
                                    min="1"
                                    max="999"
                                    step="any"
                                >
                                <span style="margin-left: .5rem;display: inline-block" class="form-indic">%</span>
                            </div>
                    
                             
                        </div>

                            <div class="w-form-group" data-bind="foreach: republishes">
                                <div class="form-group-header">
                                    <div>
                                        <span>Republish date</span>
                                        <strong data-bind="text: dateRepublished.substring(0, 10)"></strong>
                                    </div>
                                    <div>
                                        <span>Republish by</span>
                                        <strong data-bind="if: author"><span data-bind="text: author.valnet_user.fullName"></span></strong>
                                    </div>
                                </div>
                                <div class="form-group border">
                                    
                                    <dl class="double-list">
                                       
                                        <dt>
                                            <span>Author</span>
                                        </dt>
                                        <dd>
                                            <span data-bind="if: author"><span data-bind="text: author.valnet_user.fullName"></span></span>
                                        </dd>
                                        <dt>
                                            <span>Sr Editor</span>
                                        </dt>
                                        <dd>
                                            <span data-bind="if: editor"><span data-bind="text: editor.valnet_user.fullName"></span></span>
                                        </dd>
                                        <dt>
                                            <span>Jr Editor</span>
                                        </dt>
                                        <dd>
                                            <span data-bind="if: juniorEditor"><span data-bind="text: juniorEditor.valnet_user.fullName"></span></span>
                                        </dd>
                                        <dt>
                                            <span>Payment Category</span>
                                        </dt>
                                        <dd>
                                            <span data-bind="if: postPaymentCategory"><span data-bind="text: postPaymentCategory.name"></span></span>
                                        </dd>
                                    </dl>
                                </div>
                            </div>    

                        </div>
                        
                    </div>
                    
                    <div class="form-footer">                
                        <button data-bind="event: { click: onClickSync }" class="btn " type="button">Sync</button>
                        <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>   
                        <button data-bind="event: { click: onClickSave }"   class="btn highlight" type="button">Save</button>         
                    </div>
        
             
                </div>
                
                 `+this.imagePicker.getHtmlBuild()+`
                
                `;
    }

    protected initPartial():void{

        this.filterUser_author = new filterUser_template("filterUser_author", this.getTemplateViewModel(), this.caller);
        this.filterUser_SrEditor = new filterUser_template("filterUser_SrEditor", this.getTemplateViewModel(), this.caller);
        this.filterUser_JrEditor = new filterUser_template("filterUser_JrEditor", this.getTemplateViewModel(), this.caller);
        this.filterDisplay_author = new filterUser_template("filterDisplay_author", this.getTemplateViewModel(), this.caller);
        this.paymentCategoryFilter = new filterDropdown_template("paymentCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.paymentCategoryFilter.setLabel("Payment Category");
        this.datePicker = new filterSingleDate_template("filterDate", this.getTemplateViewModel(), this.caller);
        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePickerM = new imagePicker_template_mockup("imagePickerM", this.getTemplateViewModel(), this.caller);
    }

    public buildDatePickerCalendar() {
        this.datePicker.buildCalendar();
    }

    protected getTemplateName(): string{

        return "articlesEdit_template";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;

        return{
            id: ko.observable("")
            , title: ko.observable("")
            , reference: ko.observable("")
            , editor: ko.observable("")
            , datePublished: ko.observable("")
            , author: ko.observable("")
            , jrEditor: ko.observable("")
            , displayAuthor: ko.observable("")
            , isEditShown : ko.observable(false)
            , targetAudience: ko.observable("")
            , intent: ko.observable("")
            , contentType: ko.observable("")
            , networkCategory: ko.observable("")
            , postPaymentCategory: ko.observable("")
            , canSearchUsers: ko.observable(false)
            , showNewRepublish: ko.observable(false)
            , showNewRepublishButton: ko.observable(true)
            , showCancelRepublishButton: ko.observable(false)
            , allowEditPermalink: ko.observable(false)
            , amazonsiteArticleTitle: ko.observable("")
            , amazonsitePublishDate: ko.observable("")
            , articleRepublishHistory: ko.observableArray([])
            , newRepublishDate: ko.observableArray("")
            , permalink: ko.observableArray("")
            , republishes: ko.observableArray([])
            , amountAuthor: ko.observable("")
            ,percentageAuthor: ko.observable(null)
            ,percentageEditor: ko.observable(null)
            , publishStatuses: ko.observableArray([])
            , idPublishStatus: ko.observable("")
            , lastCursorPosition: ko.observable(0)
            ,paymentTypeRepublish : ko.observableArray([{name: "Amount"}, {name: "Percentage"}])
            ,choosenPaymentTypeRepublish : ko.observable(null)

            ,onClickCancel: function(data, event){
                huit_neuf_this.onClickCancel();
            }
            ,onClickSync: function(data, event){
                huit_neuf_this.onClickSync();
            }
            ,onClickSave: function(data, event){
                huit_neuf_this.onClickSave();
            }
            ,createNewRepublish: function (data, event) {
                huit_neuf_this.createNewRepublish();
            }
            ,cancelNewRepublish: function (data, event){
                huit_neuf_this.cancelNewRepublish();
            }
            ,onClickEditDisplayAuthor: function(data, event){
                huit_neuf_this.onClickEditDisplayAuthor();
            }
            ,onChangepaymentTypeRepublish: function (data, event) {
                huit_neuf_this.onChangepaymentTypeRepublish(data, event)
            }
        }
    }

    public getViewModelForRequest(){

        return{

            filters       :{
                authorId: this.getTemplateViewModel().filterUser_author.idUser,
                srEditorId: this.getTemplateViewModel().filterUser_SrEditor.idUser,
                jrEditorId: this.getTemplateViewModel().filterUser_JrEditor.idUser,
                paymentCategory: this.getTemplateViewModel().paymentCategoryFilter.selectedOption
            }
        }
    }

    protected onClickCancel(){

        this.caller.cancelEditArticle();
    }

    protected onClickSync(){

        this.caller.syncEditArticle();
    }


    protected onClickSave(){

        //if(this.getTemplateViewModel().showNewRepublish()){
        this.caller.saveEditArticle();
        //}

    }

    protected  onClickEditDisplayAuthor(){

        this.getTemplateViewModel().isEditShown(true);

    }

    public setId(id): void{

        this.getTemplateViewModel().id(id);
    }

    public setTitle(title): void{

        this.getTemplateViewModel().title(title);
    }

    public setReference(reference): void{

        this.getTemplateViewModel().reference(reference);
    }

    public setEditor(editor): void{

        this.getTemplateViewModel().editor(editor);
    }

    public setDisplayAuthor(displayAuthor): void{

        if(displayAuthor) {

            this.getTemplateViewModel().displayAuthor(displayAuthor.valnet_user.fullName);
            this.getTemplateViewModel().filterDisplay_author.users(displayAuthor);
            this.getTemplateViewModel().filterDisplay_author.user(displayAuthor.valnet_user.fullNameAndLogin);
            this.getTemplateViewModel().filterDisplay_author.idUser(displayAuthor.id);
        }
    }

    public setPermalink(permalink): void{

        this.getTemplateViewModel().permalink(permalink);
    }

    public setDatePublished(datePublished): void{

        this.getTemplateViewModel().datePublished(datePublished);
    }

    public setAuthor(author): void{

        this.getTemplateViewModel().author(author);
    }

    public setJrEditor(jrEditor): void{

        this.getTemplateViewModel().jrEditor(jrEditor);
    }

    public setTargetAudience(targetAudience): void{

        this.getTemplateViewModel().targetAudience(targetAudience);
    }

    public setIntent(intent): void{

        this.getTemplateViewModel().intent(intent);
    }

    public setContentType(contentType): void{

        this.getTemplateViewModel().contentType(contentType);
    }

    public setNetworkCategory(networkCategory): void{

        this.getTemplateViewModel().networkCategory(networkCategory);
    }

    public setPostPaymentCategory(postPaymentCategory): void{

        this.getTemplateViewModel().postPaymentCategory(postPaymentCategory);
    }

    public setAllowEditPermalink(allowEditPermalink): void{

        this.getTemplateViewModel().allowEditPermalink(allowEditPermalink);
    }

    public setAmazonsiteArticleTitle(amazonsiteArticleTitle): void{

        if(amazonsiteArticleTitle) {

            this.getTemplateViewModel().amazonsiteArticleTitle(amazonsiteArticleTitle);
        }else{

            this.getTemplateViewModel().amazonsiteArticleTitle(this.getTemplateViewModel().title());
        }
    }

    public setUsers(users){

        this.getTemplateViewModel().filterUser_author.users(users);
        this.getTemplateViewModel().filterUser_SrEditor.users(users);
        this.getTemplateViewModel().filterUser_JrEditor.users(users);
        this.getTemplateViewModel().filterDisplay_author.users(users);
    }

    public setCanSearchUsers(canSearchUsers: boolean){

        this.filterUser_author.setIsVisible(canSearchUsers);
        this.filterUser_SrEditor.setIsVisible(canSearchUsers);
        this.filterUser_JrEditor.setIsVisible(canSearchUsers);
    }

    public createNewRepublish(): void{

        this.getTemplateViewModel().showNewRepublish(true);
        this.getTemplateViewModel().showNewRepublishButton(false);
        this.getTemplateViewModel().showCancelRepublishButton(true);
    }

    public cancelNewRepublish(): void {

        this.getTemplateViewModel().filterUser_author.user("");
        this.getTemplateViewModel().filterUser_author.idUser(null);
        this.getTemplateViewModel().filterUser_SrEditor.user("");
        this.getTemplateViewModel().filterUser_SrEditor.idUser(null);
        this.getTemplateViewModel().filterUser_JrEditor.user("");
        this.getTemplateViewModel().filterUser_JrEditor.idUser(null);
        this.getTemplateViewModel().paymentCategoryFilter.setSelectedOption(null);
        this.getTemplateViewModel().showNewRepublish(false);
        this.getTemplateViewModel().showNewRepublishButton(true);
        this.getTemplateViewModel().showCancelRepublishButton(false);
        this.getTemplateViewModel().amountAuthor(null);
    }

    public setArticleRepublishData(republishes: Array<{}>): void{

        this.getTemplateViewModel().republishes(republishes);
    }

    public setPublishStatuses(publishStatuses: Array<{}>): void{

        this.getTemplateViewModel().publishStatuses(publishStatuses);
    }

    public setIdPublishStatus(idPublishStatus): void{

        this.getTemplateViewModel().idPublishStatus(idPublishStatus);
    }

    protected onChangepaymentTypeRepublish(data , event){
        let paymentTypeSelected = event.target.value

        if(paymentTypeSelected === "Amount"){
            this.getTemplateViewModel().percentageAuthor(null)
        }

        if(paymentTypeSelected === "Percentage"){
            this.getTemplateViewModel().amountAuthor(null)
        }
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/articlesEdit_template.ts